import { Component, Inject, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { NewMapComponent } from './new-map.component/new-map.component';

@Component({
  selector: 'app-new-map-form',
  standalone: false,
  templateUrl: './new-map-form.component.html',
  styleUrl: './new-map-form.component.scss',
})
export class NewMapFormComponent {
  @ViewChild('mapComponent')
  mapComponent!: NewMapComponent;
  zoom = 12;
  lat = -12.0464;
  lng = -77.0428;
  address = '';
  locationSelected = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<NewMapFormComponent>
  ) { }

  ngOnInit(): void {
  }

  handleInputChange(event: {
    lat: number;
    lng: number;
    address: string;
  }): void {
    this.lat = event.lat;
    this.lng = event.lng;
    this.address = event.address;
    this.zoom = 17;
    this.locationSelected = true;

    this.mapComponent.resetToLocation(
      event.lat,
      event.lng,
      17,
    );
  }

  accept(): void {
  this.dialogRef.close({
    lat: this.lat,
    lng: this.lng,
    address: this.address,
  });
}
}